import {
    FETCH_LANGUAGES,
    FETCH_LANGUAGES_SUCCESS,
} from "constants/ActionTypes";

const INIT_STATE = {
    languagesList: [],
    loading: false,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_LANGUAGES: {
            return {
                ...state,
                loading: true,
            }
        }
        case FETCH_LANGUAGES_SUCCESS: {
            return {
                ...state,
                languagesList: action.payload.languagesList,
                loading: false,
            }
        }
        default:
            return state;
    }
}
